/* Lyna & Tailor theme script: drawers, Ajax bag, variant picking, sticky buy bar, size guide units, sort, recommendations. */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
  var LT = window.LT || {};
  // Supplier colour names arrive as "GRAY", "navy blue", "DarkBlue" or "creamy-white"; show them one way: "Dark Blue".
  var COLOR_ALIAS = { 'changchunhua blue': 'Periwinkle Blue', 'qing shi green': 'Sage Green', 'shu mei red': 'Raspberry' };
  var niceColor = function (v) {
    var s = String(v || '').replace(/([a-z])([A-Z])/g, '$1 $2').replace(/[-_]+/g, ' ').replace(/\s+/g, ' ').trim().toLowerCase();
    return COLOR_ALIAS[s] || s.replace(/(^|\s)[a-z]/g, function (c) { return c.toUpperCase(); });
  };
  var isColor = function (name) { return /^colou?r$/i.test(String(name || '').trim()); };
  var SIZE_ORDER = ['XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', 'XXXL', '2XL', '3XL', '4XL', 'ONE SIZE'];
  var sizeRank = function (v) { var u = String(v).toUpperCase().trim().replace(/^1XL$/, 'XL'), i = SIZE_ORDER.indexOf(u); return i > -1 ? i : (isNaN(parseFloat(u)) ? 99 : 50 + parseFloat(u)); };
  // "Gray / M" style labels: sort by colour, then size in wearing order
  var byOption = function (a, b) {
    var x = a.split(' / '), y = b.split(' / ');
    for (var i = 0; i < Math.max(x.length, y.length); i++) {
      var p = x[i] || '', q = y[i] || '';
      if (p === q) continue;
      var rp = sizeRank(p), rq = sizeRank(q);
      return (rp < 99 || rq < 99) ? rp - rq : p.localeCompare(q);
    }
    return 0;
  };
  $$('.dot[data-color]').forEach(function (d) { d.title = niceColor(d.dataset.color); });
  $$('.pair__sel[data-ci]').forEach(function (sel) {
    var ci = +sel.dataset.ci;
    $$('option', sel).forEach(function (o) {
      var p = o.textContent.replace(/\s*\/\s*$/, '').split(' / ');
      if (o.value && ci > -1 && p[ci]) p[ci] = niceColor(p[ci]);
      o.textContent = p.join(' / ');
    });
    $$('option', sel).filter(function (o) { return o.value; }).sort(function (a, b) { return byOption(a.textContent, b.textContent); }).forEach(function (o) { sel.appendChild(o); });
  });
  document.addEventListener('change', function (e) { if (e.target.classList && e.target.classList.contains('pair__sel')) e.target.classList.remove('is-err'); });
  var FREE = LT.freeShip || 0;
  // clothing tiers "3:10,4:15,5:20" -> [{n:3,p:10},...]; items whose product type is LT.tierExclude don't count
  var TIERS = String(LT.tiers || '').split(',').map(function (t) { var a = t.split(':'); return { n: +a[0], p: +a[1] }; }).filter(function (t) { return t.n && t.p; }).sort(function (a, b) { return a.n - b.n; });
  var money = function (cents) {
    var v = cents / 100;
    return '$' + (v % 1 ? v.toFixed(2) : v.toFixed(0));
  };
  var json = function (url, body) {
    return fetch(url, body ? { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) } : { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Something went wrong. Please try again.'); return j; }); });
  };

  // sticky bars below the header sit at its real height
  var hdrEl = $('.hdr');
  if (hdrEl) { var setHdr = function () { document.documentElement.style.setProperty('--hdr-h', hdrEl.offsetHeight + 'px'); }; setHdr(); window.addEventListener('resize', setHdr); }

  /* ---------- drawers ---------- */
  var lastFocus = null;
  function openDrawer(id) {
    var d = document.getElementById(id); if (!d) return;
    closeAll(true); lastFocus = document.activeElement;
    d.classList.add('on'); d.setAttribute('aria-hidden', 'false'); $('#scrim').classList.add('on');
    document.documentElement.classList.add('locked');
    setTimeout(function () { var f = d.querySelector('button, a, input, select'); (f || d).focus(); }, 60);
  }
  function closeAll(keepFocus) {
    $$('.drawer.on').forEach(function (d) { d.classList.remove('on'); d.setAttribute('aria-hidden', 'true'); });
    var s = $('#scrim'); if (s) s.classList.remove('on');
    document.documentElement.classList.remove('locked');
    if (!keepFocus && lastFocus && lastFocus.focus) lastFocus.focus();
  }
  var toastT;
  function toast(t) { var el = $('#toast'); if (!el) return; el.textContent = t; el.classList.add('on'); clearTimeout(toastT); toastT = setTimeout(function () { el.classList.remove('on'); }, 2600); }

  /* ---------- bag ---------- */
  var cart = null;
  function renderCart() {
    if (!cart) return;
    var n = cart.item_count, sub = cart.total_price;
    var c = $('#cartCount'); if (c) { c.textContent = n; c.hidden = !n; }
    if (!FREE && $('#shipMsg')) {
      $('#shipMsg').textContent = !n ? (LT.shipLine || $('#shipMsg').textContent) : n < 2 ? 'Add 1 more item for free U.S. shipping' : 'Your order ships free';
    }
    renderTiers();
    var saved = cart.total_discount || 0, sr = $('#cartSaveRow');
    if (sr) { sr.hidden = !saved; $('#cartSave').textContent = '−' + money(saved); }
    if (FREE > 0 && $('#shipBar')) {
      var gap = FREE - sub;
      $('#shipMsg').textContent = n ? (gap > 0 ? 'You\'re ' + money(gap) + ' away from free U.S. shipping' : 'Your order ships free') : 'Free U.S. shipping on orders over ' + money(FREE);
      $('#shipBar').style.width = Math.min(100, sub / FREE * 100) + '%';
    }
    $('#cartLines').innerHTML = n ? cart.items.map(function (l, i) {
      var opts = (l.options_with_values || []).filter(function (o) { return o.name !== 'Title' && !/ship/i.test(o.name); }).map(function (o) { return esc(isColor(o.name) ? niceColor(o.value) : o.value); }).join(' · ');
      var img = l.image ? l.image + (l.image.indexOf('?') > -1 ? '&' : '?') + 'width=240' : '';
      return '<div class="line"><a href="' + esc(l.url) + '">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy">' : '') + '</a><div><h5><a href="' + esc(l.url) + '">' + esc(l.product_title) + '</a></h5>' +
        (opts ? '<p class="meta">' + opts + '</p>' : '') + '<p class="meta">' + (l.original_line_price > l.final_line_price ? '<span class="was">' + money(l.original_line_price) + '</span>' : '') + money(l.final_line_price) + '</p>' +
        '<div class="qty"><button type="button" data-line="' + (i + 1) + '" data-qty="' + (l.quantity - 1) + '" aria-label="Decrease quantity">–</button><span>' + l.quantity + '</span><button type="button" data-line="' + (i + 1) + '" data-qty="' + (l.quantity + 1) + '" aria-label="Increase quantity">+</button></div>' +
        '<button class="rm" type="button" data-line="' + (i + 1) + '" data-qty="0">Remove</button></div></div>';
    }).join('') : '<p class="muted" style="padding:24px 0">Your bag is empty.</p><a class="btn btn--line" href="/collections/all">Shop new arrivals</a>';
    $('#cartSub').textContent = money(sub);
    var co = $('#checkoutBtn'); if (co) co.classList.toggle('is-off', !n);
    renderPairs();
  }
  function renderTiers() {
    var box = $('#tierMeter'); if (!box || !TIERS.length || !cart) return;
    var ex = (LT.tierExclude || '').toLowerCase();
    var k = cart.items.reduce(function (sum, l) { return sum + ((l.product_type || '').toLowerCase() === ex ? 0 : l.quantity); }, 0);
    var top = TIERS[TIERS.length - 1], cur = null, next = null;
    TIERS.forEach(function (t) { if (k >= t.n) cur = t; else if (!next) next = t; });
    var piece = function (x) { return x + ' more clothing piece' + (x > 1 ? 's' : ''); };
    box.hidden = !cart.item_count;
    $('#tierMsg').textContent = !cur ? 'Add ' + piece(next.n - k) + ' to save ' + next.p + '%'
      : next ? 'You’re saving ' + cur.p + '% on clothing. Add ' + piece(next.n - k) + ' to save ' + next.p + '%'
      : 'You’re saving ' + cur.p + '% on clothing';
    $('#tierBar').style.width = Math.min(100, k / top.n * 100) + '%';
    var st = $('#tierSteps');
    if (st) st.innerHTML = TIERS.map(function (t) { return '<span class="' + (k >= t.n ? 'on' : '') + '" style="left:' + (t.n / top.n * 100) + '%">' + t.n + '+ · ' + t.p + '%</span>'; }).join('');
  }
  // "Complete the look": two pieces from the category that goes with the last thing added
  var PAIR = { blazers: 'trousers', trousers: 'shirts', shirts: 'trousers', knitwear: 'trousers', dresses: 'outerwear', outerwear: 'knitwear' };
  var pairCache = {};
  function pairOptions(p) {
    var opts = (p.options || []).map(function (o) { return o.name || o; });
    return p.variants.filter(function (v) { return v.available; }).map(function (v) {
      var parts = [];
      [v.option1, v.option2, v.option3].forEach(function (x, i) { if (x != null && !/ship/i.test(opts[i] || '')) parts.push(isColor(opts[i]) ? niceColor(x) : x); });
      return { id: v.id, t: parts.join(' / ') };
    }).sort(function (a, b) { return byOption(a.t, b.t); }).map(function (o) { return '<option value="' + o.id + '">' + esc(o.t) + '</option>'; }).join('');
  }
  function pairLabel(p) {
    return 'Choose ' + (p.options || []).map(function (o) { return (o.name || o).toLowerCase(); }).filter(function (n) { return n.indexOf('ship') < 0; }).join(' / ');
  }
  function renderPairs() {
    var box = $('#cartPairs'); if (!box) return;
    if (!cart || !cart.item_count) { box.hidden = true; return; }
    var last = cart.items[0], h = PAIR[(last.product_type || '').toLowerCase()] || 'blazers';
    var inBag = cart.items.map(function (l) { return l.product_id; });
    (pairCache[h] ? Promise.resolve(pairCache[h]) : json('/collections/' + h + '/products.json?limit=12').then(function (r) { return (pairCache[h] = r.products || []); }))
      .then(function (list) {
        var pk = list.filter(function (p) { return inBag.indexOf(p.id) < 0 && p.variants.some(function (v) { return v.available; }); }).slice(0, 2);
        if (!pk.length) { box.hidden = true; return; }
        box.innerHTML = '<span class="eyebrow">Complete the look</span>' + pk.map(function (p) {
          var src = p.images && p.images[0] ? p.images[0].src : '';
          var img = src ? src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=200' : '';
          var one = p.variants.length === 1;
          return '<div class="pair"><a class="pair__ph" href="/products/' + esc(p.handle) + '">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy">' : '') + '</a><div class="pair__b">' +
            '<a class="pair__t" href="/products/' + esc(p.handle) + '">' + esc(p.title) + '</a><span class="pair__p">' + money(Math.round(parseFloat(p.variants[0].price) * 100)) + '</span>' +
            (one ? '<button class="pair__add" type="button" data-qa-add data-vid="' + p.variants[0].id + '">+ Add</button>'
                 : '<select class="pair__sel" aria-label="Choose an option for ' + esc(p.title) + '"><option value="">' + esc(pairLabel(p)) + '</option>' + pairOptions(p) + '</select><button class="pair__add" type="button" data-qa-add>+ Add</button>') +
            '</div></div>';
        }).join('');
        box.hidden = false;
      }).catch(function () { box.hidden = true; });
  }
  function refreshCart() { return json('/cart.js').then(function (c) { cart = c; renderCart(); return c; }); }
  /* ---------- added to bag: a small note pops in under the bag icon, then drifts up into it and fades ---------- */
  function bagIcon() { return $('.hdr [data-open="cartDrawer"]'); }
  function bump() {
    [$('#cartCount'), bagIcon()].forEach(function (el) { if (!el) return; el.classList.remove('bump'); void el.offsetWidth; el.classList.add('bump'); });
  }
  var noteT;
  function hideNote() {
    var n = $('#addedNote'); if (!n || !n.classList.contains('on')) return;
    clearTimeout(noteT); n.classList.remove('on'); n.classList.add('out');
    setTimeout(function () { if (!n.classList.contains('on')) { n.hidden = true; n.classList.remove('out'); } }, 380);
  }
  function addedNote(id, qty) {
    var line = cart && cart.items.filter(function (l) { return l.variant_id === id; })[0]; if (!line) return;
    var note = $('#addedNote');
    if (!note) {
      document.body.insertAdjacentHTML('beforeend', '<div class="added" id="addedNote" role="status" aria-live="polite" hidden></div>');
      note = $('#addedNote');
      note.addEventListener('click', function (e) {
        if (e.target.closest('[data-added-bag]')) { e.preventDefault(); hideNote(); openDrawer('cartDrawer'); }
      });
      note.addEventListener('mouseenter', function () { clearTimeout(noteT); });
      note.addEventListener('mouseleave', function () { noteT = setTimeout(hideNote, 2500); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') hideNote(); });
    }
    var opts = (line.options_with_values || []).filter(function (o) { return !/ship/i.test(o.name); })
      .map(function (o) { return isColor(o.name) ? niceColor(o.value) : o.value; }).filter(function (x) { return x && x !== 'Default Title'; });
    var img = line.image ? line.image + (line.image.indexOf('?') > -1 ? '&' : '?') + 'width=160' : '';
    note.innerHTML = (img ? '<img src="' + esc(img) + '" alt="">' : '') +
      '<div class="added__b"><span>Added to bag' + (qty > 1 ? ' (' + qty + ')' : '') + '</span><small>' + esc(line.product_title + (opts.length ? ' · ' + opts.join(' / ') : '')) + '</small></div>' +
      '<a class="added__v" href="' + esc(LT.routes.cart) + '" data-added-bag>View bag</a>';
    // hang the note from the bag icon, with its little pointer under the icon
    var hdr = $('.hdr'), bag = bagIcon(), br = bag && bag.getBoundingClientRect();
    note.style.top = Math.max(8, hdr ? hdr.getBoundingClientRect().bottom + 10 : 8) + 'px';
    var right = br ? Math.max(12, window.innerWidth - br.right - 6) : 16;
    note.style.right = right + 'px';
    note.style.setProperty('--tip', (br ? Math.max(14, window.innerWidth - right - (br.left + br.width / 2) - 6) : 24) + 'px');
    note.classList.remove('out'); note.hidden = false; void note.offsetWidth; note.classList.add('on');
    clearTimeout(noteT); noteT = setTimeout(hideNote, 3000);
  }
  // after an add outside the bag: fly, bump, note (inside the open bag the list itself updates)
  function added(id, qty, from) {
    if (from && from.closest && from.closest('.drawer')) return;
    bump(); addedNote(id, qty);
  }
  function addToCart(id, qty, btn) {
    if (btn) btn.setAttribute('aria-busy', 'true');
    return json('/cart/add.js', { items: [{ id: id, quantity: qty || 1 }] })
      .then(refreshCart).then(function () { added(id, qty || 1, btn); })
      .catch(function (e) { toast(e.message); })
      .finally(function () { if (btn) btn.removeAttribute('aria-busy'); });
  }
  function changeLine(line, qty) { return json('/cart/change.js', { line: line, quantity: qty }).then(function (c) { cart = c; renderCart(); }).catch(function (e) { toast(e.message); }); }

  /* ---------- product page ---------- */
  var pj = $('#productJson');
  if (pj) {
    var product = JSON.parse(pj.textContent);
    var form = $('#pdpForm'), addBtn = $('#addBtn'), idIn = $('#pdpVariant');
    var optNames = product.options.map(function (o) { return (o.name || o).toLowerCase(); });
    var sizeIdx = optNames.indexOf('size');
    var chosen = [];
    $$('.opt').forEach(function (fs) {
      var i = +fs.dataset.opt, p = fs.querySelector('[aria-pressed="true"]');
      chosen[i] = p ? p.dataset.v : null;
    });
    if (product.variants.length === 1) chosen = product.variants[0].options.slice();
    // an option with a single value (One Size, one colour) is chosen for the shopper
    product.options.forEach(function (o, i) {
      var vals = []; product.variants.forEach(function (v) { if (vals.indexOf(v.options[i]) < 0) vals.push(v.options[i]); });
      if (vals.length !== 1) return;
      chosen[i] = vals[0];
      var fs = $('.opt[data-opt="' + i + '"]'); if (!fs) return;
      $$('[data-v]', fs).forEach(function (b) { b.setAttribute('aria-pressed', 'true'); });
      var nm = fs.querySelector('[data-opt-name]'); if (nm) nm.textContent = isColor(o.name || o) ? niceColor(vals[0]) : vals[0];
    });
    var find = function () { return product.variants.filter(function (v) { return v.options.every(function (o, i) { return chosen[i] === o; }); })[0] || null; };
    var label = function (v) { return v ? (v.available ? 'Add to bag · ' + money(v.price) : 'Sold out') : 'Add to bag'; };
    function availability() {
      // mark option values that cannot make an available variant with the other choices
      $$('.opt').forEach(function (fs) {
        var i = +fs.dataset.opt;
        $$('[data-v]', fs).forEach(function (b) {
          var ok = product.variants.some(function (v) { return v.available && v.options[i] === b.dataset.v && v.options.every(function (o, j) { return j === i || !chosen[j] || chosen[j] === o; }); });
          b.classList.toggle('is-out', !ok);
          if (i === sizeIdx) b.setAttribute('aria-label', b.dataset.v + (ok ? '' : ', sold out'));
        });
      });
    }
    // up to 7 photos: one big, the rest in pairs; an odd one out at the end spans the full width
    var GAL_MAX = 7;
    function fitGallery() {
      var gal = $('#gallery'); if (!gal) return;
      var shown = $$('figure', gal).filter(function (f) { f.classList.remove('wide'); return !f.hidden; });
      if (shown.length > 1 && (shown.length - 1) % 2) shown[shown.length - 1].classList.add('wide');
    }
    fitGallery();
    function update() {
      var v = find();
      if (v) {
        idIn.value = v.id;
        $('#pdpPrice').innerHTML = (v.compare_at_price > v.price ? '<s>' + money(v.compare_at_price) + '</s> ' : '') + money(v.price);
        var sp = $('#stickyPrice'); if (sp) sp.textContent = money(v.price);
        if (window.history.replaceState) window.history.replaceState({}, '', location.pathname + '?variant=' + v.id);
      }
      // the chosen colour's photo becomes the big first photo (even before a size is picked); the gallery keeps showing GAL_MAX
      var ci = product.options.map(function (o) { return o.name || o; }).findIndex(isColor);
      var mv = (v && v.featured_media) ? v : (ci > -1 && chosen[ci] ? product.variants.filter(function (x) { return x.options[ci] === chosen[ci] && x.featured_media; })[0] : null);
      if (mv) {
        var fig = $('[data-media="' + mv.featured_media.id + '"]'), gal = $('#gallery');
        if (fig && gal && gal.firstElementChild !== fig) {
          gal.insertBefore(fig, gal.firstElementChild); fig.hidden = false;
          var shown = $$('figure:not([hidden])', gal); if (shown.length > GAL_MAX) shown[shown.length - 1].hidden = true;
          fitGallery();
          if (window.innerWidth > 900) { if (fig.getBoundingClientRect().top < 0) fig.scrollIntoView({ behavior: 'smooth', block: 'nearest' }); }
          else gal.scrollTo({ left: 0, behavior: 'smooth' });
        }
      }
      addBtn.textContent = label(v); addBtn.disabled = !!(v && !v.available);
      renderQty();
      var bnow = $('#buyNow'); if (bnow) bnow.hidden = !!(v && !v.available);
      availability();
    }
    form.addEventListener('click', function (e) {
      var b = e.target.closest('[data-v]'); if (!b) return;
      var fs = b.closest('.opt'), i = +fs.dataset.opt;
      chosen[i] = b.dataset.v;
      $$('[data-v]', fs).forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
      var nm = fs.querySelector('[data-opt-name]'); if (nm) nm.textContent = b.classList.contains('swatch') ? niceColor(b.dataset.v) : b.dataset.v;
      $('#sizeErr').textContent = '';
      update();
    });
    // the chosen variant, or null after asking for the missing size/colour
    function pick() {
      var missing = $$('.opt').filter(function (fs) { return !chosen[+fs.dataset.opt]; });
      if (missing.length) {
        $('#sizeErr').textContent = 'Choose a ' + (product.options[+missing[0].dataset.opt].name || 'size').toLowerCase() + ' to add this to your bag.';
        $('#buyBox').scrollIntoView({ behavior: 'smooth', block: 'center' });
        return null;
      }
      var v = find(); return v && v.available ? v : null;
    }
    function buyNow(btn) {
      var items = qtyItems(); if (!items) return;
      btn.setAttribute('aria-busy', 'true');
      json('/cart/add.js', { items: items })
        .then(function () { location.href = '/checkout'; })
        .catch(function (e) { btn.removeAttribute('aria-busy'); toast(e.message); });
    }
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var items = qtyItems(); if (!items) return;
      addBtn.setAttribute('aria-busy', 'true');
      var st = $('#stickyAdd'), from = e.submitter || (st && st.getBoundingClientRect().top < window.innerHeight - 4 ? st : addBtn);
      json('/cart/add.js', { items: items }).then(refreshCart).then(function () { added(items[0].id, items[0].quantity, from); })
        .catch(function (er) { toast(er.message); }).finally(function () { addBtn.removeAttribute('aria-busy'); });
    });
    /* ----- quantity stepper next to Add to bag ----- */
    var qIn = $('#pdpQty'), QMAX = 10;
    var qty = function () { var n = parseInt(qIn && qIn.value, 10); return n > 0 ? Math.min(n, QMAX) : 1; };
    function renderQty() {
      if (!qIn) return;
      var n = qty(), v = find(); qIn.value = n;
      $('#qtyMinus').disabled = n <= 1; $('#qtyPlus').disabled = n >= QMAX;
      var bd = $('#bdl'), bp = bd ? (JSON.parse(bd.dataset.prices || '{}')[n]) : null;
      if (v && v.available) addBtn.textContent = 'Add to bag · ' + money(bp ? bp : v.price * n);
    }
    function qtyItems() {
      // bundle: one colour/size pick per piece
      var sl = $$('#bdlSlots select');
      if (sl.length > 1) {
        var miss = sl.filter(function (x) { return !x.value; })[0];
        if (miss) { $('#sizeErr').textContent = 'Choose a colour and size for every piece.'; miss.focus(); return null; }
        $('#sizeErr').textContent = '';
        var q = {}; sl.forEach(function (x) { q[x.value] = (q[x.value] || 0) + 1; });
        return Object.keys(q).map(function (id) { return { id: +id, quantity: q[id] }; });
      }
      var v = pick(); return v ? [{ id: v.id, quantity: qty() }] : null;
    }
    // bundle slots: rebuild when the bundle size changes
    function bdlSlots() {
      var box = $('#bdlSlots'); if (!box) return;
      var n = qty(), old = $$('select', box).map(function (x) { return x.value; });
      if (n < 2) { box.innerHTML = ''; box.hidden = true; return; }
      var cur = find(), opts = product.variants.filter(function (v) { return v.available; }).map(function (v) {
        var t = [v.option1, v.option2, v.option3].filter(function (x, i) { return x != null && !/ship/i.test((product.options[i] && (product.options[i].name || product.options[i])) || ''); }).map(function (x) { return niceColor(x); }).join(' / ');
        return '<option value="' + v.id + '">' + esc(t) + '</option>';
      }).join('');
      var h = '';
      for (var i = 0; i < n; i++) h += '<label class="bdl__slot"><span>Piece ' + (i + 1) + '</span><select aria-label="Colour and size for piece ' + (i + 1) + '"><option value="">Choose colour / size</option>' + opts + '</select></label>';
      box.innerHTML = h; box.hidden = false;
      $$('select', box).forEach(function (x, i) { var v = old[i] || (cur && chosenAll() ? String(cur.id) : ''); if (v) x.value = v; });
    }
    function chosenAll() { return $$('.opt').every(function (fs) { return chosen[+fs.dataset.opt]; }); }
    if (qIn) {
      $('#qtyMinus').addEventListener('click', function () { qIn.value = qty() - 1; renderQty(); });
      $('#qtyPlus').addEventListener('click', function () { qIn.value = qty() + 1; renderQty(); });
      qIn.addEventListener('change', function () { renderQty(); bdlSlots(); });
      renderQty();
    }
    var bn = $('#buyNow'); if (bn) bn.addEventListener('click', function () { buyNow(bn); });
    var sbn = $('#stickyBuyNow'); if (sbn) sbn.addEventListener('click', function () { buyNow(sbn); });
    // size buttons in wearing order (admin order follows whatever the supplier listed first)
    $$('.opt .sizes').forEach(function (box) { $$('[data-v]', box).sort(function (a, b) { return sizeRank(a.dataset.v) - sizeRank(b.dataset.v); }).forEach(function (b) { box.appendChild(b); }); });
    $$('.swatch[data-v]').forEach(function (b) { var t = niceColor(b.dataset.v); b.title = t; b.setAttribute('aria-label', t); var fs = b.closest('.opt'), nm = fs && fs.querySelector('[data-opt-name]'); if (nm && b.getAttribute('aria-pressed') === 'true') nm.textContent = t; });
    availability();
    var sb = $('#stickyBuy');
    if (sb && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (en) {
        en.forEach(function (x) { var on = !x.isIntersecting && x.boundingClientRect.top < 0; sb.classList.toggle('on', on); sb.setAttribute('aria-hidden', String(!on)); $('#stickyAdd').tabIndex = on ? 0 : -1; if (sbn) sbn.tabIndex = on ? 0 : -1; });
      }).observe(addBtn);
      $('#stickyAdd').addEventListener('click', function () { if (form.requestSubmit) form.requestSubmit(); else addBtn.click(); });
    }
  }

  /* ---------- recommendations (Pair it with) ---------- */
  $$('[data-rec]').forEach(function (el) {
    fetch(el.dataset.url).then(function (r) { return r.text(); }).then(function (html) {
      var tmp = document.createElement('div'); tmp.innerHTML = html;
      var sec = tmp.querySelector('[data-rec-loaded]'); if (sec) el.replaceWith(sec); else el.remove();
    }).catch(function () { el.remove(); });
  });

  /* ---------- global clicks ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target, el;
    if ((el = t.closest('[data-open]'))) { e.preventDefault(); openDrawer(el.dataset.open); return; }
    if (t.closest('[data-close]') || t.closest('#scrim')) { closeAll(); return; }
    if ((el = t.closest('[data-line]'))) { changeLine(+el.dataset.line, +el.dataset.qty); return; }
    if ((el = t.closest('[data-qa-add]'))) {
      var sel = el.parentNode.querySelector('.pair__sel'), vid = sel ? sel.value : el.dataset.vid;
      if (!vid) { if (sel) { sel.focus(); sel.classList.add('is-err'); } toast('Choose a size first'); return; }
      addToCart(+vid, 1, el); return;
    }
    if ((el = t.closest('[data-unit]'))) {
      var sg = el.closest('[data-sg]'), u = el.dataset.unit;
      $$('[data-unit]', sg).forEach(function (b) { b.setAttribute('aria-pressed', String(b.dataset.unit === u)); });
      $$('[data-in]', sg).forEach(function (td) { var v = parseFloat(td.dataset.in); td.textContent = u === 'in' ? v + '"' : Math.round(v * 2.54) + ' cm'; });
      return;
    }
    if (t.closest('#checkoutBtn.is-off')) { e.preventDefault(); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });
  document.addEventListener('change', function (e) {
    if (e.target.matches('[data-sort]')) { var u = new URL(location.href); u.searchParams.set('sort_by', e.target.value); u.searchParams.delete('page'); location.href = u.toString(); }
  });

  /* contact/review forms: stamp messages typed by a person; the hidden Website box catches form-filling bots */
  $$('[data-human]').forEach(function (stamp) {
    var f = stamp.form, hp = f && f.querySelector('.hp input'); if (!f) return;
    var mark = function () { stamp.value = hp && hp.value ? 'bot-trap' : ['real', 'person', 'lyna'].join('-'); };
    f.addEventListener('keydown', mark, { once: true }); f.addEventListener('submit', mark);
  });

  refreshCart().catch(function () {});
})();
